import React, { useEffect, useState } from "react";
import { connect, useSelector } from "react-redux";
import * as clientReducer from "../../Redux/client/reducer";
import Feedback from "../../Utilities/Feedback";
import { Col, Row } from "antd";
import SearchJobs from "../../Utilities/SearchJobs";
import constants from "../../Redux/constants";
import SearchBar from "../../Utilities/SearchBar";
import { LoadingOutlined } from "@ant-design/icons";
import JobCard from "../../Utilities/JobCard";
import Pagination from "../../Utilities/Pagination";
import { StyledLink } from "../../styled-components/components";
import { useHistory } from "react-router";
import { Helmet } from "react-helmet";
import ClientProfileCompletion from "../Profile/ClientProfileCompletion";

const ViewAllJobs = (props) => {
  const history = useHistory();
  const { getAllJobs } = props;
  const [page, setPage] = useState(0);
  const [fetchingJobs, setFetchingJobs] = useState(true);
  const [isSearching, setIsSearching] = useState(false);
  const [searchText, setSearchText] = useState("");
  const getPage = (page) => {
    setPage(page - 1);
  };
  useEffect(() => {
    const fetchAllJobs = async () => {
      setFetchingJobs(true);
      const { responseStatus } = await getAllJobs(page);
      if (responseStatus === constants.status.success) {
        setFetchingJobs(false);
      }
    };
    fetchAllJobs(page);
  }, [getAllJobs, page]);

  const { allJobs, totalJobsCount } = useSelector((state) => state.clientStore);

  const getSearchText = async (searchText) => {
    setIsSearching(true);
    setSearchText(searchText);
  };
  const hideSearchResults = () => {
    setIsSearching(false);
  };
  return (
    <Col xs={{ span: 24 }}>
      <Helmet title="Home | Unicon" />
      {fetchingJobs ? (
        <Feedback icon={<LoadingOutlined />} title="Fetching all the jobs" />
      ) : (
        <Col>
          <Row justify="center">
            <Col md={{ span: 11 }} style={{ margin: "1vh" }}>
              <SearchBar
                searchHolder="Search Jobs"
                getSearchText={getSearchText}
                hideSearchResults={hideSearchResults}
              />
            </Col>
          </Row>
          <Col
            style={{ margin: "1vh", marginTop: 0 }}
            xs={{ span: 5 }}
            md={{ span: 7 }}
            lg={{ span: 7 }}
            xl={{ span: 6 }}
          ></Col>
          {isSearching ? (
            <Col>
              <SearchJobs searchText={searchText} />
            </Col>
          ) : (
            <Col>
              <ClientProfileCompletion />

              {allJobs.length === 0 ? (
                <Feedback
                  status="warning"
                  title="No Jobs Found"
                  subTitle={
                    <StyledLink
                      onClick={() => history.push("/client/new-job")}
                      data-testId="submit-createJob"
                    >
                      Create a new job
                    </StyledLink>
                  }
                ></Feedback>
              ) : (
                <Col>
                  <ClientProfileCompletion />
                  {allJobs &&
                    allJobs.map((eachJob) => (
                      <JobCard
                        key={eachJob.jobId}
                        id={eachJob.jobId}
                        title={eachJob.title}
                        typeRequirement={eachJob.typeRequirement}
                        targetStartDate={eachJob.targetStartDate}
                        targetEndDate={eachJob.targetEndDate}
                        applicationsCount={eachJob.applicationsCount}
                        userId={eachJob.userId}
                        createdDate={eachJob.createdDate}
                        t24Release={
                          eachJob.T24ProfileData
                            ? eachJob.T24ProfileData.T24Release
                            : null
                        }
                        additionalComments={eachJob.additionalComments}
                      ></JobCard>
                    ))}
                  <Row justify="center">
                    <Pagination totalJobs={totalJobsCount} getPage={getPage} />
                  </Row>
                </Col>
              )}
            </Col>
          )}
        </Col>
      )}
    </Col>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAllJobs: (page) => dispatch(clientReducer.getAllJobs(page)),
  };
};

export default connect(null, mapDispatchToProps)(ViewAllJobs);
